module.exports = __webpack_public_path__ + "static/media/lc_sep.79005379.png";